<template>
  <div class="panel-in-tab">
    <!-- <el-header height="auto" ref="header">
        <search-bar v-model="formData" @search="handleSearch" @onCollapse="onCollapse" ref="search"></search-bar>
      </el-header> -->
    <search-box class="search-box">
      <el-form :model="formData" :inline="true" size="mini" label-width="70px">
        <el-form-item label="商品编码" prop="goodsCode">
          <el-input v-model="formData.goodsCode" placeholder="请输入商品编码"></el-input>
        </el-form-item>
        <el-form-item label="商品名称" prop="goodsName">
          <el-input v-model="formData.goodsName" placeholder="请输入商品名称"></el-input>
        </el-form-item>
        <el-form-item label="平台名称" prop="platformName">
          <el-select v-model="formData.platformName" multiple collapse-tags filterable>
            <el-option v-for="(item,index) in platformNameList" :label="item.platformname" :key="item.platformname + index" :value="item.platformname"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="店铺">
          <el-select v-model="formData.storeId" filterable placeholder="全部">
            <el-option label="全平台" :key="'all-store'" :value="''"></el-option>
            <el-option v-for="(item, index) in useObjectList" :label="item.name" :key="index" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上市时间">
          <form-date-range
            :form="formData"
            startKey="marketonStart"
            :usingTime="false"
            endKey="marketonEnd"
            valueFormat="yyyy-MM-dd"
          ></form-date-range>
        </el-form-item>
        <el-form-item label="付款时间">
          <form-date-range
            :form="formData"
            startKey="planTimeStart"
            :usingTime="false"
            endKey="planTimeEnd"
            valueFormat="yyyy-MM-dd"
          ></form-date-range>
        </el-form-item>
      </el-form>
      <template v-slot:right>
        <el-button type="primary" size="mini" @click="onSearch">搜索</el-button>
        <el-button class="orange-btn" size="mini" @click="onReset">重置</el-button>
      </template>
    </search-box>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="onExport">导出</el-button>
        <el-button type="primary" size="mini" @click="tableVisible = true">表格设置</el-button>
      </template>
      <el-table
        border
        stripe
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        :data="tableData"
        :height="maxTableHeight"
        @sort-change="handleSortChange"
        v-if="tableHeight && tableReload"
        v-loading="loading"
      >
        <el-table-column
          :label="item.label"
          :prop="item.prop"
          :min-width="item.width"
          :fixed="item.fixed"
          :sortable="item.sortable ? 'custom' : false"
          show-overflow-tooltip
          v-for="(item,index) in columnData"
          :key="item.prop + '' + index"
        >
          <template slot-scope="scope">
            <template v-if="item.label === '图片'">
              <template v-if="showDetailBtn(scope.row)">
                <el-link :underline="false" type="primary" @click="showDialog(scope.row, 0)">查看</el-link>
              </template>
            </template>
            <span
              v-else-if="
                ['goodsCode', 'goodsName', 'category', 'marketon', 'dailyRetailPrice', 'planTime', 'monthSaleNum', 'monthSaleAmount','skuPromotionName'].includes(item.prop) ||
                formData.storeId
              "
            >
              {{ scope.row[item.prop] }}
            </span>
            <span
              v-else-if="item.label.includes('同比')"
              :style="{ color: scope.row[item.prop] && scope.row[item.prop].includes('-') ? '#F56C6C' : '#0BB78E' }"
            >
              {{ scope.row[item.prop] }}
            </span>
            <el-link type="primary" :underline="false" @click="viewSales(scope)" v-else>{{ scope.row[item.prop] }}</el-link>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div class="footerBox">
          <div>
            <span>{{ timeText.updateContent ? '数据刷新时间：' : '' }}</span>
            <span>{{ timeText.latestUpdateTime ? timeText.latestUpdateTime : '' }}</span>
          </div>
          <div>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="paginationOpt.pageNum"
              :page-sizes="paginationOpt.pageSizes"
              :page-size="paginationOpt.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="paginationOpt.total"
            ></el-pagination>
          </div>
        </div>
      </template>
    </table-panel>
    <el-dialog :visible.sync="recordDialogVisible" title="销量情况" width="45%">
      <div>
        <el-table
          :data="recordData"
          v-loading="loading2"
          border
          :height="300"
          element-loading-text="数据加载中"
          element-loading-spinner="el-icon-loading"
          :header-cell-style="{
            backgroundColor: '#FAFAFA',
            textAlign: 'center',
          }"
          :cell-style="{ textAlign: 'center' }"
          style="width: 100%"
        >
          <el-table-column prop="storeName" label="店铺"></el-table-column>
          <el-table-column prop="sale" label="销量" v-if="!columnType"></el-table-column>
          <el-table-column prop="saleAmount" label="销售金额" v-if="columnType"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- 导入导出 -->
    <import-export ref="importExport" @onsuccess="init"></import-export>
    <!-- 视频、图片查看 -->
    <pic-video v-model="picVideoVisible" :data="rowData" :detailType="viewType" v-if="picVideoVisible"></pic-video>

    <!-- 自定义列 -->
    <custom-table
      v-model="tableVisible"
      :tableDataSet="tableDataSet"
      v-if="tableVisible"
      @closeAddForm="closeAddForm"
      @confirm="confirm"
    ></custom-table>
  </div>
</template>

<script>
import importExportMxin from './import&export.mixin';
import picVideoMxin from './pic&video.mixin';
import moment from 'moment';
import customPropsMixin from './customProps.mixin';
import tableMixin from '@/utils/tableMixin';
import axios from '@/utils/axiosInstance';
export default {
  name: 'CommoditySales',
  mixins: [importExportMxin, customPropsMixin, picVideoMxin, tableMixin],
  components: {},
  data() {
    return {
      tableHeight: 0,
      loading: false,
      loading2: false,
      formData: {
        storeId: '',
        goodsCode: '',
        goodsName: '',
        platformName: [],
        marketonStart: '',
        marketonEnd: '',
        planTimeStart: moment(new Date()).subtract(6, 'months').format('YYYY-MM-DD'),
        planTimeEnd: moment(new Date()).subtract('months').format('YYYY-MM-DD'),
      },
      tableData: [],
      paginationOpt: {
        pageSizes: [30, 60, 90],
        pageSize: 30,
        pageNum: 1,
        total: 0,
      },
      exportData: {},
      columnsData: [],
      recordDialogVisible: false,
      recordData: [],
      useObjectList: [],
      platformNameList: [],
      timeText: {},
      columnType: false,
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: '',
        param: {},
        queryMatch: [],
        orderList: [],
        orderType: '',
        hasCount: 'N',
        groupAttr: '',
      },
    };
  },
  // watch: {
  //   $route: {
  //     handler(val, olv) {
  //       var query = val.query ? val.query : {};
  //       if (
  //         olv.path == '/dataBoard/newProductStatistics' &&
  //         (query.marketOnBegin != this.formData.marketonStart || query.marketOnEnd != this.formData.marketonEnd) &&
  //         JSON.stringify(val.query) != '{}'
  //       ) {
  //         this.formData.marketonStart = query.marketOnBegin;
  //         this.formData.marketonEnd = query.marketOnEnd;
  //         this.onSearch();
  //       }
  //     },
  //   },
  // },
  mounted() {
    let query = this.$route.query;
    if (query.marketOnBegin && query.marketOnEnd) {
      this.formData.marketonStart = query.marketOnBegin;
      this.formData.marketonEnd = query.marketOnEnd;
      this.formData.planTimeStart = query.planTimeStart;
      this.formData.planTimeEnd = query.planTimeEnd;
    }
    this.tableHeight = window.innerHeight - 275;
    this.init();
    this.refreshTime();
    this.salesGetStore();
    this.getPlatformName();
  },
  methods: {
    handleSearch(data) {
      this.paginationOpt.pageNum = 1;
      this.formData = data;
      this.init();
    },
    viewSales(scope) {
      this.recordData = [];
      this.recordDialogVisible = true;
      this.loading2 = true;
      let formData = {
        goodsCode: scope.row.goodsCode.includes('全部') 
          ? (this.formData.goodsCode ? this.formData.goodsCode : '') 
          : scope.row.goodsCode,
        goodsName: scope.row.goodsName,
        payMonth: scope.column.property,
        planTimeStart: this.formData.planTimeStart,
        planTimeEnd: this.formData.planTimeEnd,
        platformName: this.formData.platformName,
        goodsName: this.formData.goodsName,
        boolSumRow: scope.$index == 0 && this.paginationOpt.pageNum == 1 ? 1 : 0
      };
      this.columnType = scope.column.label.includes('销售额');
      let apiType = this.columnType ? this.$q.commoditySales.storeSaleAmount : this.$q.commoditySales.storeSales;
      apiType({ data: formData })
        .then(res => {
          if (res.data.length && res.code == 200) {
            console.log(res);
            this.recordData = res.data;
          } else {
            this.recordData = [];
          }
        })
        .finally(_ => {
          this.loading2 = false;
        });
    },
    onSearch() {
      this.paginationOpt.pageNum = 1;
      this.salesGetStore();
      this.init();
    },
    onReset() {
      this.$refs.tableRef.clearSort();
      this.formData = {
        storeId: '',
        platformName: [],
        planTimeStart: moment(new Date()).subtract(6, 'months').format('YYYY-MM-DD'),
        planTimeEnd: moment(new Date()).subtract('months').format('YYYY-MM-DD'),
      };
      this.onSearch();
    },
    init(type) {
      this.loading = true;
      let formData = {
        pageSize: this.paginationOpt.pageSize,
        pageNum: this.paginationOpt.pageNum,
        filterData: {
          ...this.formData,
          ...this.orderDto,
        },
      };
      this.exportData = formData;
      this.$q.commoditySales
        .merchandiseSearch({ data: formData })
        .then(res => {
          if (res.data.records.length && res.code == 200) {
            if (!type) {
              this.pagingColumnData = res.data.titleList;
              this.customColumn();
            }
            this.tableData = res.data.records;
            this.paginationOpt['total'] = res.data.total;
          } else {
            this.tableData = [];
          }
        })
        .finally(_ => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.paginationOpt.pageSize = val;
      this.paginationOpt.pageNum = 1;
      this.init(1);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.paginationOpt.pageNum = val;
      this.init(1);
    },
    onCollapse() {
      // 搜索栏折叠展开的动画结束后才能计算最新的dom高度。不能用this.$nextTick替代。
      setTimeout(_ => {
        this.tableHeight = this.$refs['wrapper'].offsetHeight - this.$refs['search'].$el.offsetHeight - 91;
      }, 500);
    },
    handleSortChange({ column, prop, order }) {
      this.paginationOpt.pageNum = 1;
      this.orderDto = {
        sortField: prop,
        sortOptions: order === 'ascending' ? '0' : order === 'descending' ? '1' : '',
      };
      this.init(1);
    },
    //平台名称
    getPlatformName() {
      let data = { ...this.currencyForm };
      data.reportCode = 'platformNameQuery';
      axios.post(`/ec-pc-api/custom/reports/data/platformNameQuery`, data).then((res) => {
        if (res.code == 200) {
          this.platformNameList = res.data.list
        }
      });
    },
    async refreshTime() {
      let res = await this.$q.common.refreshTime({ fragment: [52] });
      this.timeText = res.data;
    },
    salesGetStore() {
      const params = {
        params: {
          planTimeStart: this.formData.planTimeStart,
          planTimeEnd: this.formData.planTimeEnd,
        },
      };
      this.$q.commoditySales.salesGetStore(params).then(res => {
        this.useObjectList = res.data;
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.panel-in-tab
  >>> .search-outer>div
    padding 0
.footerBox
  display flex
  justify-content space-between
  align-items center
.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
    width 240px !important
>>> .date-range .single-date
  width 110px !important
</style>
